wbApp.controller('StudentsTaxDeductionReportParamsCtrl', ['$scope', '$window',
function ($scope, $window) {

    $scope.model = {
        selectedYear: 2018,
        maxYear: moment().year()
    };

    var endOfApril = moment().startOf('year').add(4, 'M').endOf('month');
    if (moment().isBefore(endOfApril)) {
        $scope.model.selectedYear = moment().startOf('year').subtract(1, 'year').year();
    } else {
        $scope.model.selectedYear = moment().startOf('year').year();
    }

    $scope.onReportPrint = function (model) {

        if ($scope.isSaving) {
            return;
        }

        $scope.isSaving = true;

        $scope.$hide();

        var fromDate = moment().year($scope.model.selectedYear).startOf('year').toDate();
        var toDate = moment().year($scope.model.selectedYear).endOf('year').toDate();

        $window.open('/Admin/Report/ActivityYearPaymentConfirmation' +
            '?StudentID=' + $scope.studentID +
            '&StartDate=' + fromDate.toJSON() +
            '&EndDate=' + toDate.toJSON(),
            '_blank', 'width=1000,height=500,toolbar=no,resizable=yes,location=no,directories=no,status=no,menubar=no,copyhistory=no');
    }

    $scope.onExportReportToXls = function (model) {

        if ($scope.isSaving) {
            return;
        }

        $scope.isSaving = true;

        $scope.$hide();

        var fromDate = moment().year($scope.model.selectedYear).startOf('year').toDate();
        var toDate = moment().year($scope.model.selectedYear).endOf('year').toDate();

        $("#dataDownloadIFrame").remove();
        $("body").append("<iframe id='dataDownloadIFrame' src='/Admin/Report/ActivityYearPaymentConfirmation?StudentID=" + $scope.studentID + '&StartDate=' + fromDate.toJSON() + '&EndDate=' + toDate.toJSON() + "&format=xls' style='height: 0px;' ></iframe>");
    }


}]);
